<template>
  <layout>
    <page-header header="Edit user" />
    <div class="content">
      <resource-form
        :id="$route.params.id"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'users'

export default {
  name: 'UsersEdit',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
